import React from 'react'
import './SvgIcon.css'
import IconShow from '../../assets/icons/icons-show.svg'
import IconHide from '../../assets/icons/icons-hide.svg'
import IconError from '../../assets/icons/icons-error.svg'
import IconWarning from '../../assets/icons/icons-warning.svg'
import Next from '../../assets/icons/Next.svg'
import Back from '../../assets/icons/Back.svg'
import ResponseOK from '../../assets/icons/icons-response-ok.svg'
import CheckCircle from '../../assets/icons/icons-check-circle.svg'
import IconSearch from '../../assets/icons/icons-search.svg'
import Plus from '../../assets/icons/icons-plus.svg'
import Trash from '../../assets/icons/icons-trash.svg'
import Remove from '../../assets/icons/icons-remove-item.svg'
import Download from '../../assets/icons/icons-cloud-download.svg'
import CircleClock from '../../assets/icons/check-circle-clock-icon.svg'
import WarningRed from '../../assets/icons/icons-error-red.svg'
import WarningImages from '../../assets/icons/icons-warning-images.svg'
import ArrowUp from '../../assets/icons/arrow-up.svg'
import ArrowUpGreen from '../../assets/icons/arrowUpGreen.svg'
import ArrowDown from '../../assets/icons/arrow-down.svg'
import Sale from '../../assets/icons/icons-currency.svg'
import AmipassWhite from '../../assets/icons/amipass-white.svg'
import IconSales from '../../assets/icons/icon-sales.svg'

// Icons new home
import IconBag from '../../assets/icons/icon-bag.svg'
import IconBell from '../../assets/icons/icon-bell.svg'
import IconCart from '../../assets/icons/icon-cart.svg'
import IconCaht from '../../assets/icons/icon-chat.svg'
import IconConfigV2 from '../../assets/icons/icon-configv2.svg'
import IconData from '../../assets/icons/icon-data.svg'
import IconDollar from '../../assets/icons/icon-dollar.svg'
import IconDown from '../../assets/icons/icon-down.svg'
import IconEco from '../../assets/icons/icon-eco.svg'
import IconFraction from '../../assets/icons/icon-fraction.svg'
import IconHome from '../../assets/icons/icon-home.svg'
import IconInvoice from '../../assets/icons/icon-invoice.svg'
import IconRight from '../../assets/icons/icon-right.svg'
import IconList from '../../assets/icons/icon-list.svg'
import IconLogout from '../../assets/icons/icon-logout.svg'
import IconoMtorcycle from '../../assets/icons/icon-motorcycle.svg'
import IconPadlock from '../../assets/icons/icon-padlock.svg'
import IconPercentageBag from '../../assets/icons/icon-percentage-bag.svg'
import IconPercentage from '../../assets/icons/icon-percentage.svg'
import IconQr from '../../assets/icons/icon-qr.svg'
import IconStorev2 from '../../assets/icons/icon-storev2.svg'
import IconSummary from '../../assets/icons/icon-summary.svg'
import IconSuscription from '../../assets/icons/icon-suscription.svg'
import IconTerminal from '../../assets/icons/icon-terminal.svg'
import IconUsers from '../../assets/icons/icon-users.svg'
import IconChatWhite from '../../assets/icons/icon-chat-white.svg'
import IconPadlockWhite from '../../assets/icons/icon-padlock-white.svg'
import Chile from '../../assets/icons/chile.svg'
import IconLeftBlue from '../../assets/icons/icon-left-blue.svg'
import IconHola from '../../assets/icons/icon-hola.svg'
import IconTrophy from '../../assets/icons/icon-trophy.svg'
import IconObject from '../../assets/icons/icon-object.svg'
import IconCheckGreen from '../../assets/icons/icon-check-green.svg'
import IconLockedColor from '../../assets/icons/icon-locked-color.svg'
import IconX from '../../assets/icons/icon-x.svg'
import IconWarningWhite from '../../assets/icons/icon-warning-white.svg'
import IconUploadImage from '../../assets/icons/icons-upload-image.svg'
import IconChevronDown from '../../assets/icons/icons-chevron-down.svg'
import IconTimeReload from '../../assets/icons/timeReload.svg'
import CartProduct from '../../assets/icons/cart-product.svg'
import IconAmipass from '../../assets/icons/icon-amipass.svg'
import IconsEditAltBlue from '../../assets/icons/icons-edit-alt-blue.svg'
import StackedBarChart from '../../assets/icons/stacked_bar_chart.svg'
import IconAddProducts from '../../assets/icons/icon-add-products.svg'
import IconArrowLeft from '../../assets/icons/arrow_left.svg'
import IconsTrashAlt from '../../assets/icons/icons-trash-alt.svg'
import IconsEditAlt from '../../assets/icons/icons-edit-alt.svg'
import IconTrashRed from '../../assets/icons/icon-trash-red.svg'
import IconInfoBlue from '../../assets/icons/info-blue.svg'
import IconXWhite from '../../assets/icons/x-white.svg'
import SaleIlusGreen from '../../assets/icons/sale_ilus_green.svg'

// Billing
import BIconsBeenHere from '../../assets/icons/billing/icons-been-here.svg'
import BIconsBuildings from '../../assets/icons/billing/icons-buildings.svg'
import BIconsCalendarCheck from '../../assets/icons/billing/icons-calendar-check.svg'
import BIconsCalendar from '../../assets/icons/billing/icons-calendar.svg'
import BIconsColumns from '../../assets/icons/billing/icons-columns.svg'
import BIconsDetail from '../../assets/icons/billing/icons-detail.svg'
import BIconsDiscount from '../../assets/icons/billing/icons-discount.svg'
import BIconsEnvelope from '../../assets/icons/billing/icons-envelope.svg'
import BIconsIdCard from '../../assets/icons/billing/icons-id-card.svg'
import BIconsStore from '../../assets/icons/billing/icons-store.svg'
import BIconsTicketMoney from '../../assets/icons/billing/icons-ticket-money.svg'
import BIconsTicket from '../../assets/icons/billing/icons-ticket.svg'
import BIconsUser from '../../assets/icons/billing/icons-user.svg'
import ArrowLeftBlue from '../../assets/icons/arrow-left-blue.svg'
import PdfIcon from '../../assets/icons/Pdf.svg'

// Plan
import PIconMyBusiness from '../../assets/icons/plan/mi-local.svg'
import PIconMyPlan from '../../assets/icons/plan/mi-plan.svg'
import PIconAddons from '../../assets/icons/plan/complementos.svg'
import OtherPaymentMethod from '../../assets/icons/plan/otros-metodos-de-pago.svg'
import PIconCheck from '../../assets/icons/plan/check-feature.svg'
import PIconChevronDown from '../../assets/icons/plan/chevron-down.svg'
import PIconChevronUp from '../../assets/icons/plan/chevron-up.svg'
import PIconLocked from '../../assets/icons/plan/locked.svg'
import PIconStar from '../../assets/icons/plan/star.svg'

interface SvgIconProps {
    iconName: IconName
    width?: string | number | undefined
    height?: string | number | undefined
}
interface IconNames {
    [name: string]: IconName
}
export const iconNames: IconNames = {
    show: 'show',
    hide: 'hide',
    search: 'search',
    error: 'error',
    warning: 'warning',
    shortArrowNext: 'shortArrowNext',
    shortArrowBack: 'shortArrowBack',
    responseOK: 'responseOK',
    checkCircle: 'checkCircle',
    plus: 'plus',
    trash: 'trash',
    remove: 'remove',
    download: 'download',
    circleClock: 'circleClock',
    warningRed: 'warningRed',
    warningImages: 'warningImages',
    arrowUp: 'arrowUp',
    arrowDown: 'arrowDown',
    sale: 'sale',
    AmipassWhite: 'AmipassWhite',
    IconBag: 'IconBag',
    IconBell: 'IconBell',
    IconCart: 'IconCart',
    IconCaht: 'IconCaht',
    IconConfigV2: 'IconConfigV2',
    IconData: 'IconData',
    IconDollar: 'IconDollar',
    IconDown: 'IconDown',
    IconEco: 'IconEco',
    IconFraction: 'IconFraction',
    IconHome: 'IconHome',
    IconInvoice: 'IconInvoice',
    IconRight: 'IconRight',
    IconList: 'IconList',
    IconLogout: 'IconLogout',
    IconoMtorcycle: 'IconoMtorcycle',
    IconPadlock: 'IconPadlock',
    IconPercentageBag: 'IconPercentageBag',
    IconPercentage: 'IconPercentage',
    IconQr: 'IconQr',
    IconStorev2: 'IconStorev2',
    IconSummary: 'IconSummary',
    IconSuscription: 'IconSuscription',
    IconTerminal: 'IconTerminal',
    IconUsers: 'IconUsers',
    IconChatWhite: 'IconChatWhite',
    IconPadlockWhite: 'IconPadlockWhite',
    Chile: 'Chile',
    IconLeftBlue: 'IconLeftBlue',
    IconHola: 'IconHola',
    IconTrophy: 'IconTrophy',
    IconObject: 'IconObject',
    IconCheckGreen: 'IconCheckGreen',
    IconLockedColor: 'IconLockedColor',
    IconX: 'IconX',
    IconWarningWhite: 'IconWarningWhite',
    ArrowUpGreen: 'ArrowUpGreen',
    BIconsBeenHere: 'BIconsBeenHere',
    BIconsBuildings: 'BIconsBuildings',
    BIconsCalendarCheck: 'BIconsCalendarCheck',
    BIconsCalendar: 'BIconsCalendar',
    BIconsColumns: 'BIconsColumns',
    BIconsDetail: 'BIconsDetail',
    BIconsDiscount: 'BIconsDiscount',
    BIconsEnvelope: 'BIconsEnvelope',
    BIconsIdCard: 'BIconsIdCard',
    BIconsStore: 'BIconsStore',
    BIconsTicketMoney: 'BIconsTicketMoney',
    BIconsTicket: 'BIconsTicket',
    BIconsUser: 'BIconsUser',
    IconUploadImage: 'IconUploadImage',
    IconChevronDown: 'IconChevronDown',
    IconTimeReload: 'IconTimeReload',
    CartProduct: 'CartProduct',
    IconAmipass: 'IconAmipass',
    IconsEditAltBlue: 'IconsEditAltBlue',
    StackedBarChart: 'StackedBarChart',
    IconAddProducts: 'IconAddProducts',
    IconArrowLeft: 'IconArrowLeft',
    IconsTrashAlt: 'IconsTrashAlt',
    IconsEditAlt: 'IconsEditAlt',
    IconTrashRed: 'IconTrashRed',
    IconInfoBlue: 'IconInfoBlue',
    IconXWhite: 'IconXWhite',
    SaleIlusGreen: 'SaleIlusGreen',
    IconSales: 'IconSales',
    ArrowLeftBlue: 'ArrowLeftBlue',
    PIconMyBusiness: 'PIconMyBusiness',
    PIconMyPlan: 'PIconMyPlan',
    PIconAddons: 'PIconAddons',
    OtherPaymentMethod: 'OtherPaymentMethod',
    PIconCheck: 'PIconCheck',
    PIconChevronDown: 'PIconChevronDown',
    PIconChevronUp: 'PIconChevronUp',
    PIconLocked: 'PIconLocked',
    PIconStar: 'PIconStar',
    PdfIcon: 'PdfIcon',
}
const icons = {
    show: IconShow,
    hide: IconHide,
    search: IconSearch,
    error: IconError,
    warning: IconWarning,
    shortArrowNext: Next,
    shortArrowBack: Back,
    responseOK: ResponseOK,
    checkCircle: CheckCircle,
    plus: Plus,
    trash: Trash,
    remove: Remove,
    download: Download,
    circleClock: CircleClock,
    warningRed: WarningRed,
    warningImages: WarningImages,
    arrowUp: ArrowUp,
    arrowDown: ArrowDown,
    sale: Sale,
    AmipassWhite: AmipassWhite,
    IconBag: IconBag,
    IconBell: IconBell,
    IconCart: IconCart,
    IconCaht: IconCaht,
    IconConfigV2: IconConfigV2,
    IconData: IconData,
    IconDollar: IconDollar,
    IconDown: IconDown,
    IconEco: IconEco,
    IconFraction: IconFraction,
    IconHome: IconHome,
    IconInvoice: IconInvoice,
    IconRight: IconRight,
    IconList: IconList,
    IconLogout: IconLogout,
    IconoMtorcycle: IconoMtorcycle,
    IconPadlock: IconPadlock,
    IconPercentageBag: IconPercentageBag,
    IconPercentage: IconPercentage,
    IconQr: IconQr,
    IconStorev2: IconStorev2,
    IconSummary: IconSummary,
    IconSuscription: IconSuscription,
    IconTerminal: IconTerminal,
    IconUsers: IconUsers,
    IconChatWhite: IconChatWhite,
    IconPadlockWhite: IconPadlockWhite,
    Chile: Chile,
    IconLeftBlue: IconLeftBlue,
    IconHola: IconHola,
    IconTrophy: IconTrophy,
    IconObject: IconObject,
    IconCheckGreen: IconCheckGreen,
    IconLockedColor: IconLockedColor,
    IconX: IconX,
    IconWarningWhite: IconWarningWhite,
    ArrowUpGreen: ArrowUpGreen,
    BIconsBeenHere: BIconsBeenHere,
    BIconsBuildings: BIconsBuildings,
    BIconsCalendarCheck: BIconsCalendarCheck,
    BIconsCalendar: BIconsCalendar,
    BIconsColumns: BIconsColumns,
    BIconsDetail: BIconsDetail,
    BIconsDiscount: BIconsDiscount,
    BIconsEnvelope: BIconsEnvelope,
    BIconsIdCard: BIconsIdCard,
    BIconsStore: BIconsStore,
    BIconsTicketMoney: BIconsTicketMoney,
    BIconsTicket: BIconsTicket,
    BIconsUser: BIconsUser,
    IconUploadImage: IconUploadImage,
    IconChevronDown: IconChevronDown,
    IconTimeReload: IconTimeReload,
    CartProduct: CartProduct,
    IconAmipass: IconAmipass,
    IconsEditAltBlue: IconsEditAltBlue,
    StackedBarChart: StackedBarChart,
    IconAddProducts: IconAddProducts,
    IconArrowLeft: IconArrowLeft,
    IconsTrashAlt: IconsTrashAlt,
    IconsEditAlt: IconsEditAlt,
    IconTrashRed: IconTrashRed,
    IconInfoBlue: IconInfoBlue,
    IconXWhite: IconXWhite,
    SaleIlusGreen: SaleIlusGreen,
    IconSales: IconSales,
    ArrowLeftBlue: ArrowLeftBlue,
    PIconMyBusiness: PIconMyBusiness,
    PIconAddons: PIconAddons,
    PIconMyPlan: PIconMyPlan,
    OtherPaymentMethod: OtherPaymentMethod,
    PIconCheck: PIconCheck,
    PIconChevronDown: PIconChevronDown,
    PIconChevronUp: PIconChevronUp,
    PIconLocked: PIconLocked,
    PIconStar: PIconStar,
    PdfIcon: PdfIcon,
}

export default function SvgIcon(props: SvgIconProps) {
    const Component = icons[props.iconName]
    return (
        <img
            className="icon"
            src={Component}
            width={props.width}
            height={props.height}
        />
    )
}
